import React from "react"
import starstreamPNG from "../../../../assets/images/starstream.png"
import styles from "./index.module.css"

const PageHeader = () => {
  return (
    <header className={styles.header}>

        <div className={styles.brand}>
            <img src={starstreamPNG} className={styles.icon}></img>
            <div className={styles.starstream}>starstream</div>
        </div>

        <div className={styles.scannerName}>
            QR Code Scanner
        </div>

    </header>
  )
}

export default PageHeader
